import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowDown",
  "use": "icon-arrowDown-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrowDown\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.116 4.77516C1.30055 4.56727 1.61223 4.55431 1.81215 4.74621L7.88241 10.5727L13.9527 4.74621C14.1526 4.55431 14.4643 4.56727 14.6488 4.77516C14.8334 4.98305 14.8209 5.30714 14.621 5.49904L8.21657 11.6463C8.02785 11.8274 7.73697 11.8274 7.54826 11.6463L1.14385 5.49904C0.943922 5.30714 0.931455 4.98305 1.116 4.77516Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol